export default __webpack_public_path__ + "static/media/Horne Houston 5.9da67b8a.jpg";